export const getPickTypeSpace8 = (option) => {
  switch (option) {
    case 'count_win':
      return 'count_win'
    case 'sum_win':
      return 'sum_win'
    case 'sum_home_ball_odd_even':
      return 'sum_home_ball_odd_even'
    case 'sum_away_ball_odd_even':
      return 'sum_away_ball_odd_even'
    case 'home_ball1_odd_even':
      return 'home_ball1_odd_even'
    case 'away_ball1_odd_even':
      return 'away_ball1_odd_even'
    case 'home_ball1_under_over':
      return 'home_ball1_under_over'
    case 'away_ball1_under_over':
      return 'away_ball1_under_over'
    default:
      return null
  }
}

export const getPickTypeDoubleDragon = (option) => {
  switch (option) {
    case 'ball_1_odd_even':
      return 'ball_1_odd_even'
    case 'ball_2_odd_even':
      return 'ball_2_odd_even'
    default:
      return null
  }
}
